import React, { Fragment } from "react";
import "./App.css";
import Navbar from "./app/layout/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import Title from "./app/layout/Title";
import { ToastContainer } from "react-toastify";
import { useNetworkBanner } from "./hooks/useNetworkBanner";
import { useVerifyAccessToken } from "./hooks/useVerifyAccessToken";

function App() {
  const location = useLocation();
  useNetworkBanner();
  useVerifyAccessToken(); // Verify access token on app load

  const authRoutes = [
    "/sign-up",
    "/log-in",
    "/2fa",
    "/activate",
    "/not-activated",
    "/forgot-password",
    "/reset-forgot-password",
  ];
  const isAuthRoute = authRoutes.includes(location.pathname);
  return (
    <Fragment>
      <ToastContainer
        position='top-center'
        autoClose={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        theme='colored'
      />
      {isAuthRoute ? (
        <>
          <Title />
          <Outlet />
        </>
      ) : (
        <div style={{ margin: 0, padding: 0 }} className='p-0 m-0 box-border'>
          <Navbar />
          <Outlet />
        </div>
      )}
    </Fragment>
  );
}

export default App;
